<template>
  <div ref="topBar">
    <SfTopBar class="topbar" v-if="isShow">
      <template #center>
        <div v-if="TopBar" v-html="TopBar.content"></div>
      </template>
      <template #right>
        <div style="display: flex">
        <SfIcon @click="closeTopbar" color="var(--c-text)" size="18px" icon="cross" />
        </div>
      </template>
    </SfTopBar>
  </div>
</template>

<script>
import { SfButton, SfTopBar, SfImage, SfIcon } from '@storefront-ui/vue';
import { computed, ref } from '@nuxtjs/composition-api';
import { addBasePath } from "@vue-storefront/core";
export default {
  name: 'TopBar',
  components: {
    SfTopBar,
    SfButton,
    SfImage,
    SfIcon
  },
  setup(props, context) {
    const topBar = ref();
    const isShow = ref(false);
    const ShowTopBar = computed(
      () => context?.root?.$cookies.get('isHiddeTopBar')
    );
    const TopBar = computed(
      () => context?.root?.$options?.$mallConfig?.mall_web_config.TopBar
    );
    if ((!ShowTopBar.value || ShowTopBar.value.show) && TopBar?.value?.content) {
      isShow.value = true;
    }
    const closeTopbar = () => {
      context?.root?.$cookies.set('isHiddeTopBar', {show: false});
      isShow.value = false;
    };
    return {
      addBasePath,
      isShow,
      TopBar,
      closeTopbar,
      topBar
    };
  }
};

</script>
<style lang="scss">
.topbar {
  position: relative;
  z-index: 2;
  .sf-top-bar__container{
    height:auto !important;
    align-items: baseline !important;
  }

  &__button {
    margin: 0 0 0 var(--spacer-xs);
  }
}
.footer__social-image{
  margin-left:0.5rem;
}
</style>
